import ReactDOM from 'react-dom';
import promiseFinally from 'promise.prototype.finally';
import React from 'react';
import { HashRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'mobx-react';
import 'react-block-ui/style.css';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';

import App from './components/App';

import userStore from './stores/UserStore';
import roomStore from './stores/RoomStore';
import policyStore from './stores/PolicyStore';
import announcementStore from './stores/AnnouncementStore';
import issueStore from './stores/IssueStore';

const stores = {
  userStore,
  roomStore,
  policyStore,
  announcementStore,
  issueStore
};

// For easier debugging
window._____APP_STATE_____ = stores;

promiseFinally.shim();

ReactDOM.render((
  <Provider {...stores}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js